<template>
  <footer aria-label="Footer">
    <!-- Top footer -->
    <div
      v-if="!compact"
      class="bg-[color:var(--color-footer-top-bg)] pt-8 text-[color:var(--color-footer-top-text)] md:flex lg:pt-20 print:hidden"
    >
      <div class="container mx-auto grid grid-cols-1 gap-4 py-4 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4">
        <!-- Logo column -->
        <div class="xl:block">
          <VcImage :src="siteLogoUrl" :alt="$context.storeName" class="mb-4 h-8" lazy />

          <div class="mt-2 flex flex-wrap">
            <SocialLinks footer />
          </div>
        </div>

        <!-- Column 1 -->
        <div v-if="footerListLeft.length">
          <div v-if="storeId === 'veldkoeltechniek-intern'" class="mb-3 text-base font-extrabold">
            {{ $cfg.footerTitleLeftIntern }}
          </div>
          <div v-else class="mb-3 text-base font-extrabold">
            {{ $cfg.footerTitleLeft }}
          </div>
          <div class="flex flex-col space-y-1">
            <FooterLink v-for="item in footerListLeft" :key="item.id" :title="item.title" :to="item.route!" />
          </div>
        </div>

        <!-- Column 2 -->
        <div v-if="footerListCenterLeft.length">
          <div class="mb-3 text-base font-extrabold">
            {{ $cfg.footerTitleCenterLeft }}
          </div>
          <div class="flex flex-col space-y-1">
            <FooterLink v-for="item in footerListCenterLeft" :key="item.id" :title="item.title" :to="item.route!" />
          </div>
        </div>

        <!-- Column 3 -->
        <div v-if="footerListCenterRight.length">
          <div class="mb-3 text-base font-extrabold">
            {{ $cfg.footerTitleCenterRight }}
          </div>
          <div class="flex flex-col space-y-1">
            <FooterLink v-for="item in footerListCenterRight" :key="item.id" :title="item.title" :to="item.route!" />
          </div>
        </div>

        <!-- Column 4 -->
        <div v-if="footerListRight.length">
          <div class="mb-3 text-base font-extrabold">
            {{ $cfg.footerTitleRight }}
          </div>
          <div class="flex flex-col space-y-1">
            <FooterLink v-for="item in footerListRight" :key="item.id" :title="item.title" :to="item.route!" />
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom footer -->
    <div
      class="flex min-h-20 flex-col justify-center bg-[color:var(--color-footer-bottom-bg)] py-4 text-xs font-medium text-[color:var(--color-footer-bottom-text)] sm:items-center print:flex-row print:bg-[color:var(--color-white)] print:px-0 print:text-[color:var(--color-black)]"
    >
      <div class="container mx-auto">
        <div v-if="footerListBottom" class="mb-2 flex flex-col sm:flex-row">
          <FooterLink v-for="item in footerListBottom" :key="item.id" :title="item.title" :to="item.route!" />
        </div>

        <div class="text-center">
          <div>{{ "&copy;" + new Date().getFullYear() }} {{ $t("shared.layout.footer.copyright") }}</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useNavigations, useThemeContext } from "@/core/composables";
import { SocialLinks } from "@/shared/layout";
import FooterLink from "../_internal/footer-link.vue";
import { globals } from "@/core/globals";

interface IProps {
  compact?: boolean;
}

defineProps<IProps>();

const { footerListLeft, footerListCenterLeft, footerListCenterRight, footerListRight, footerListBottom } =
  useNavigations();
const { storeId } = globals;

const { themeContext } = useThemeContext();
const siteLogoUrl = computed(() => themeContext.value?.settings?.logo_inverted_image);
</script>
